import { render, staticRenderFns } from "./RequestAdministration.vue?vue&type=template&id=b12d0870"
import script from "./RequestAdministration.vue?vue&type=script&lang=js"
export * from "./RequestAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports